import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function AboutPage() {
  const { user } = useAuth()
  return (
    <div style={{ paddingTop: '4.5rem', background: 'var(--paper)', minHeight: '100vh' }}>

      {/* Hero */}
      <section style={s.hero}>
        <div style={s.marginLine} />
        <div style={s.heroInner}>
          <p style={s.eyebrow}>about the margins</p>
          <h1 style={s.title}>
            built for the opinions<br />
            <span style={{ color: 'var(--accent)' }}>worth the argument.</span>
          </h1>
          <p style={s.heroSub}>
            social media rewards speed, volume, and whatever the algorithm decides is worth amplifying today.
            considered opinions — the ones that take a position and defend it — rarely make it through.
          </p>
          <p style={s.heroSub}>
            the margins exists for those.
          </p>
        </div>
      </section>

      <div style={s.cut} />

      {/* Story */}
      <section style={s.story}>
        <div style={s.storyInner}>
          <p style={s.sectionTag}>the story</p>
          <div style={s.storyGrid}>
            <div>
              <p style={s.storyP}>the margins started as a journal — long-form, considered, the kind of thing you'd actually sit with. that DNA is still here.</p>
              <p style={s.storyP}>but the problem we kept coming back to was bigger than format: where do you go when you have something real to say and no platform built for it?</p>
              <p style={s.storyP}>twitter buries nuance. instagram isn't built for argument. reddit has its own culture and its own ceiling. and most of what's left optimises for reach, not depth.</p>
            </div>
            <div>
              <p style={s.storyP}>so we built the margins as an open platform — for anyone with a perspective worth defending. a 17-year-old's take on why the education system is failing sits here alongside a considered argument about culture, politics, or what a film is actually saying.</p>
              <p style={s.storyP}>both are welcome. both deserve an audience. both need somewhere that takes the argument seriously.</p>
              <p style={s.storyP}>that's the margins.</p>
            </div>
          </div>
        </div>
      </section>

      <div style={s.cut} />

      {/* What we stand for */}
      <section style={s.beliefs}>
        <div style={s.beliefsInner}>
          <p style={s.sectionTag}>what we stand for</p>
          {[
            { n: '01', title: "your perspective doesn't need a platform.", body: "you don't need a following, a blue tick, or a byline. you need a point of view and the willingness to defend it. the margins is where that's enough." },
            { n: '02', title: "mean it. that's the only rule.", body: "we don't moderate opinions — we moderate reasoning. a take backed by evidence stands here regardless of how uncomfortable it makes people. an empty take doesn't, regardless of how popular it might be elsewhere." },
            { n: '03', title: 'impact over reach.', body: "we don't optimise for impressions. a piece that genuinely shifts how someone thinks is worth more here than content that performs well and disappears. depth is the metric." },
            { n: '04', title: 'the considered argument is a radical act.', body: 'in a media environment built for speed and reaction, taking time to actually think something through — and write it down — is increasingly rare. that\'s what we\'re here for.' },
          ].map((b, i) => (
            <div key={i} style={s.beliefItem} className="mitem-hover">
              <span style={s.beliefNum} className="belief-num">{b.n}</span>
              <div>
                <p style={s.beliefTitle} className="belief-title">{b.title}</p>
                <p style={s.beliefBody} className="belief-body">{b.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div style={s.cut} />

      {/* The Press */}
      <section style={s.pressSection}>
        <div style={s.pressInner}>
          <p style={s.sectionTag}>the press — how recognition works</p>
          <h2 style={s.pressHed}>the more you show up,<br />the more you earn.</h2>
          <p style={s.pressSub}>
            every piece you publish earns column inches. every reaction, every comment.
            twelve ranks — each one a record of how much you've shown up with something to say.
            the voice is by appointment only. you can't optimise your way there. it means something.
          </p>
          <Link to="/dashboard" style={s.pressLink}>see your rank →</Link>
        </div>
      </section>

      <div style={s.cut} />

      {/* Find us */}
      <section style={s.socials}>
        <div style={s.socialsInner}>
          <p style={s.sectionTag}>find us elsewhere</p>
          <div style={s.socialsList}>
            {[
              { name: 'instagram', handle: '@themargins_journal', url: 'https://www.instagram.com/themargins_journal/', desc: 'excerpts and behind the scenes.' },
              { name: 'discord', handle: 'the margins server', url: 'https://discord.gg/MRbakEXjPM', desc: 'the conversation continues here.' },
              { name: 'linkedin', handle: 'the margins journal', url: 'https://www.linkedin.com/company/the-margins-journal/', desc: 'updates and announcements.' },
            ].map((s2, i) => (
              <a key={i} href={s2.url} target="_blank" rel="noreferrer" style={s.socialCard} className="post-hover">
                <div style={s.socialName}>{s2.name}</div>
                <div style={s.socialHandle}>{s2.handle}</div>
                <div style={s.socialDesc}>{s2.desc}</div>
                <span style={s.socialArrow}>→</span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <div style={s.cut} />

      {/* CTA */}
      <section style={{ padding: '5rem 2rem', textAlign: 'center' }}>
        <p style={s.sectionTag}>ready?</p>
        <h2 style={{ ...s.pressHed, marginBottom: '1rem' }}>write something worth arguing about.</h2>
        <p style={{ ...s.pressSub, margin: '0 auto 2rem', textAlign: 'center' }}>
          sign up, start writing. no waiting list, no approval. just your perspective and somewhere it actually lands.
        </p>
        <Link to={user ? '/write' : '/auth'} style={s.ctaBtn}>start writing →</Link>
      </section>

    </div>
  )
}

export function JoinPage() {
  // Redirect-style — just show about page content
  return <AboutPage />
}

const s = {
  hero: { padding: '6rem 2rem 5rem', position: 'relative', overflow: 'hidden', borderBottom: '1px solid var(--rule)' },
  marginLine: { position: 'absolute', left: '2rem', top: 0, bottom: 0, width: 2, background: 'var(--accent)', opacity: .4 },
  heroInner: { paddingLeft: '2.8rem', maxWidth: 660 },
  eyebrow: { fontFamily: "'DM Mono', monospace", fontSize: '.54rem', letterSpacing: '.2em', color: 'var(--accent)', marginBottom: '1.5rem' },
  title: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 'clamp(2.2rem,6vw,4.5rem)', lineHeight: .92, letterSpacing: '-.03em', color: 'var(--ink)', marginBottom: '2rem' },
  heroSub: { fontSize: '1.05rem', lineHeight: 1.8, color: 'var(--muted)', maxWidth: '52ch', marginBottom: '.9rem' },
  cut: { height: 1, background: 'var(--rule)' },
  story: { padding: '5rem 2rem' },
  storyInner: { paddingLeft: '2.8rem', borderLeft: '2px solid var(--rule)' },
  sectionTag: { fontFamily: "'DM Mono', monospace", fontSize: '.54rem', letterSpacing: '.2em', color: 'var(--accent)', marginBottom: '1.8rem' },
  storyGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', maxWidth: 860 },
  storyP: { fontSize: '1.05rem', lineHeight: 1.85, color: 'var(--muted)', marginBottom: '1rem' },
  beliefs: { padding: '5rem 2rem', background: 'var(--cream)' },
  beliefsInner: { paddingLeft: '2.8rem', maxWidth: 660 },
  beliefItem: { padding: '1.4rem 0', borderBottom: '1px solid var(--rule)', display: 'flex', alignItems: 'flex-start', gap: '1.2rem', transition: 'all .2s', cursor: 'default' },
  beliefNum: { fontFamily: "'Bebas Neue', sans-serif", fontSize: '2.5rem', color: 'var(--accent)', lineHeight: .9, flexShrink: 0, transition: 'all .2s', width: 36 },
  beliefTitle: { fontFamily: "'Space Grotesk', sans-serif", fontSize: '1.05rem', fontWeight: 700, color: 'var(--muted)', lineHeight: 1.4, letterSpacing: '-.01em', transition: 'color .2s', paddingTop: '.2rem' },
  beliefBody: { fontSize: '.85rem', color: 'var(--ink)', fontWeight: 400, marginTop: '.3rem', lineHeight: 1.6, transition: 'color .2s' },
  pressSection: { padding: '5rem 2rem' },
  pressInner: { paddingLeft: '2.8rem', borderLeft: '2px solid var(--rule)', maxWidth: 560 },
  pressHed: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: 'clamp(1.6rem,4vw,2.8rem)', lineHeight: .95, color: 'var(--ink)', letterSpacing: '-.02em', marginBottom: '.75rem' },
  pressSub: { fontSize: '.95rem', color: 'var(--muted)', lineHeight: 1.75, marginBottom: '1.5rem', maxWidth: '46ch' },
  pressLink: { fontFamily: "'DM Mono', monospace", fontSize: '.6rem', letterSpacing: '.1em', color: 'var(--accent)', textDecoration: 'none' },
  socials: { padding: '5rem 2rem', background: 'var(--cream)' },
  socialsInner: { paddingLeft: '2.8rem' },
  socialsList: { display: 'flex', flexDirection: 'column', border: '1px solid var(--rule)', maxWidth: 600 },
  socialCard: { display: 'flex', alignItems: 'center', gap: '1.5rem', padding: '1.25rem 1.5rem', borderBottom: '1px solid var(--rule)', textDecoration: 'none', transition: 'background .15s', cursor: 'pointer', position: 'relative' },
  socialName: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: '.95rem', color: 'var(--ink)', minWidth: 90 },
  socialHandle: { fontFamily: "'DM Mono', monospace", fontSize: '.54rem', color: 'var(--muted)', letterSpacing: '.06em', flex: 1 },
  socialDesc: { fontSize: '.82rem', color: 'var(--muted)' },
  socialArrow: { fontFamily: "'DM Mono', monospace", fontSize: '1rem', color: 'var(--muted)', marginLeft: 'auto' },
  ctaBtn: { fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: '.95rem', color: 'var(--paper)', background: 'var(--ink)', padding: '.7rem 1.8rem', border: 'none', cursor: 'pointer', textDecoration: 'none', display: 'inline-block', transition: 'all .2s' },
}
